












import useI18n from '@/composables/use-i18n'
import { defineComponent, onMounted } from '@nuxtjs/composition-api'
import { LogName } from '~/interfaces/Logger'
import ggoLogger from '~/modules/ggo-logger'

export default defineComponent({
  props: {
    error: {
      type: String,
      default: '',
    },
  },
  setup (props) {
    const i18n = useI18n()

    const img = `https://cdn.gogoout.com/web/error/${i18n.locale}_error.png`

    onMounted(() => {
      ggoLogger.info(LogName.TOAST, {
        type: 'danger',
        message: props.error,
      })
    })

    return {
      img,
    }
  },
})
